import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

const PasswordInput = (props) => {
  const { label, placeholder, errorMessage, onChange, id, ...inputProps } =
    props;
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFocus = (e) => {
    setFocused(true);
  };
  return (
    <div className="formInput relative ">
      <label>{label}</label>

      <input
        className="h-[45px]"
        {...inputProps}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={handleFocus}
        onFocus={() => inputProps.name === "text" && setFocused(true)}
        focused={focused.toString()}
      />
      <span>{errorMessage}</span>

      <div className="text-2xl absolute top-[42px] right-5">
        <div
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
        >
          {showPassword ? (
            <div className="cursor-pointer bg-transparent z-10">
              <EyeSlashIcon className="text-[#B0B6BA] h-6" />
            </div>
          ) : (
            <div className="cursor-pointer bg-transparent z-10">
              <EyeIcon className="text-[#B0B6BA] h-6" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordInput;
